import React from 'react'
import PropTypes from 'prop-types'
import {Text, Stack, useMultiStyleConfig} from '@chakra-ui/react'
import {FormattedMessage, useIntl} from 'react-intl'
import OrderCancellationForm from './order-cancellation-form'

const OrderCancellationDetails = React.memo(({order, onSubmit}) => {
    const styles = useMultiStyleConfig('Orders')
    const {formatDate} = useIntl()

    return (
        <>
            <Text {...styles.confirmCancellationText}>
                <FormattedMessage
                    defaultMessage="Confirm order cancellation"
                    id="account_order_detail.label.title_order_cancellation"
                />
            </Text>
            <Stack {...styles.cancellationStack}>
                {order?.orderedDate && (
                    <Text textStyle="head-xsmall" color="text.default" fontWeight="500">
                        <FormattedMessage
                            defaultMessage="Date: {date}"
                            id="account_order_detail.label.date"
                            values={{
                                date: formatDate(new Date(order.orderedDate), {
                                    year: 'numeric',
                                    month: '2-digit',
                                    day: '2-digit',
                                }),
                            }}
                        />
                    </Text>
                )}
                {order?.orderNumber && (
                    <Text textStyle="head-medium" color="text.default" fontWeight="500">
                        <FormattedMessage
                            id="account_order_detail.label.order_number"
                            defaultMessage="Order number: {orderNumber}"
                            values={{
                                orderNumber: order.orderNumber,
                            }}
                        />
                    </Text>
                )}
                <Text {...styles.bodyMedium} fontWeight="400">
                    <FormattedMessage
                        id="account_order_detail.label.cancel_reason"
                        defaultMessage="You may cancel your order for a short time after creation. In ordoer to do so, please state the reason for the cancellation."
                    />
                </Text>
                <OrderCancellationForm onSubmit={onSubmit} />
            </Stack>
        </>
    )
})

OrderCancellationDetails.propTypes = {
    order: PropTypes.object,
    onSubmit: PropTypes.func,
}
OrderCancellationDetails.displayName = 'order-cancellation-details'
export default OrderCancellationDetails
